<template>
    <div class="col-lg-12">
        <div class="card stretch stretch-full">
            <div class="card-header">
                <h5 class="card-title">Barınak Listesi</h5>
                <div class="card-header-action">
                    <div class="card-header-btn">
                        <div data-bs-toggle="tooltip" title="Yenile">
                            <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                data-bs-toggle="refresh"> </button>
                        </div>
                        <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                            <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                data-bs-toggle="expand"> </a>
                        </div>
                    </div>
                    <div class="dropdown">
                        <a href="javascript:void(0);" class="avatar-text avatar-sm" data-bs-toggle="dropdown"
                            data-bs-offset="25, 25">
                            <div data-bs-toggle="tooltip" title="Seçenekler">
                                <i class="feather-more-vertical"></i>
                            </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <router-link to="/shelter/add" class="dropdown-item"><i class="feather-plus-circle"></i>Yeni
                                Ekle</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body custom-card-action p-0">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Barınak Adı</th>
                                <th scope="col">Konumu</th>
                                <th scope="col">Açıklama</th>
                                <th scope="col">Bağlı Depo</th>
                                <th scope="col" class="text-end">İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="shelter in shelters" :key="shelter.id">
                                <td>
                                    <div class="hstack gap-3">
                                        <div class="avatar-text bg-soft-primary text-primary">
                                            <i class="feather-book-open"></i>
                                        </div>
                                        <div>
                                            <router-link :to="{ name: 'ShelterEdit', params: { id: shelter.id } }"
                                                class="d-block mb-1">{{ shelter.name }}</router-link>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <a class="d-block mb-1">{{ shelter.location }}</a>
                                    </div>
                                </td>
                                <td>{{ shelter.description }}</td>
                                <td>{{ shelter.warehouse }}</td>
                                <td>
                                    <div class="hstack gap-2 justify-content-end">
                                        <router-link :to="{ name: 'ShelterEdit', params: { id: shelter.id } }"
                                            class="avatar-text avatar-md bg-orange">
                                            <i class="feather-eye fs-16"></i>
                                        </router-link>
                                        <a href="#" @click="deleteShelter(shelter.id)"
                                            class="avatar-text avatar-md bg-red">
                                            <i class="feather-delete fs-16"></i>
                                        </a>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer">
                <Pagination :currentPage="currentPage" :totalPages="totalPages" :next="next" :previous="previous"
                    @page-changed="fetchData" />
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import Pagination from '@/components/common/Pagination.vue';

export default {
    name: 'ShelterTable',
    components: {
        Pagination
    },
    data() {
        return {
            shelters: [],
            currentPage: 1,
            totalPages: 1,
            next: true,
            previous: false
        }
    },
    async mounted() {
        const page = Number(this.$route.params.page) || 1;
        await this.fetchData(page);
    },
    watch: {
        '$route.params.page'(newPage) {
            this.fetchData(Number(newPage));
        }
    },
    methods: {
        async fetchData(page = 1) {
            console.log('fetch data called');
            try {
                const response = await this.$axios.get(`animal_shelter/?page=${page}`);
                console.log('response:', response.data);
                this.shelters = response.data.results;
                this.totalPages = Math.ceil(response.data.count / 10);
                this.currentPage = page;
                this.next = response.data.next;
                this.previous = response.data.previous;
            } catch (error) {
                Swal.fire('Hata!', `${error}`, 'error');
            }
        },
        async deleteShelter(id) {
            const result = await Swal.fire({
                title: "Silmek istediğinizden emin misiniz?",
                text: "Bu işlem geri alınamaz!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "Hayır, iptal et"
            });

            if (result.isConfirmed) {
                try {
                    await this.$axios.delete(`animal_shelter/${id}/`);
                    Swal.fire("Başarılı!", "Kayıt silindi.", "success");

                    // this.shelters.splice(this.shelters.findIndex(shelter => shelter.id === id), 1);
                    this.fetchData();
                } catch (err) {
                    Swal.fire("Hata!", "Silme işlemi başarısız.", "error");
                    console.error(err);
                }
            }
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    }
}
</script>